import { styled } from 'dripsy';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { View } from 'react-native';

import { Line, Separator } from '@components';
import { MessagingFooter } from './MessagingFooter';
import { MessagingHeader } from './MessagingHeader';
import { MessagesList } from './MessagesList';
import { useMessaging } from '../hooks/useMessaging';

const Container = styled(View)({
  flex: 1,
  bg: '$background0',
});

export const Messaging = observer(() => {
  const { conversation, fetchMoreMessages } = useMessaging();

  if (!conversation) {
    return null;
  }

  return (
    <Container>
      <MessagingHeader />
      <Separator size="$5" />
      <Line />
      <MessagesList
        list={conversation.messages}
        fetchMore={fetchMoreMessages}
      />
      <MessagingFooter conversationId={conversation.id} />
    </Container>
  );
});
